import { makeRe } from 'micromatch';

const globToRegEx = (str: string): RegExp =>
  new RegExp(
    `^${makeRe(str, { contains: true }).source}(?:/(?:$|#|\\?)|\\?|#|$)`,
  );

const filterRoutes = new Map(
  [
    '/login',
    '/logout',
    '/**/login',
    '/register',
    '/passwordreset',
    '/passwordreset/?*',
    '/static/*',
    '/static/**/*',
  ].map((str) => [str, globToRegEx(str)]),
);

export default filterRoutes;
